// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___-2RqX","open":"open___119tG","header":"header___3nk2R","content":"content___1ZBG_"};